import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../diccionarios/indicadoresVivosModulo';

@Injectable({
  providedIn: 'root'
})
export class VersionesService {

  diccionarioUrl: any;
  urlPresupuestoComercial: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlPresupuestoComercial = this.utilServices.getPresupuestoComercial();
    this.diccionarioUrl = indicadoresVivosModulo.url.versiones;
  }

  getVersiones() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.obtenerTodo);
  }

  getVersionActiva() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.obtenerVersionActiva);
  }

  saveVersiones(innObj: any) {
    console.log("saveVersiones", innObj)
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.crear, innObj);
  }

  updateVersiones(innObj: any) {
    console.log("updateVersiones", innObj)
    return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.actualizar, innObj);
  }

  deleteVersiones(innIdDireccion: string) {
    return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.eliminar+ `${innIdDireccion}`);
  }
}
